/*! @license DOMPurify 3.3.2 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.3.2/LICENSE */
const {
  entries: Et,
  setPrototypeOf: mt,
  isFrozen: jt,
  getPrototypeOf: Vt,
  getOwnPropertyDescriptor: Xt
} = Object;
let {
  freeze: S,
  seal: O,
  create: de
} = Object, {
  apply: Fe,
  construct: He
} = typeof Reflect < "u" && Reflect;
S || (S = function(n) {
  return n;
});
O || (O = function(n) {
  return n;
});
Fe || (Fe = function(n, s) {
  for (var i = arguments.length, c = new Array(i > 2 ? i - 2 : 0), m = 2; m < i; m++)
    c[m - 2] = arguments[m];
  return n.apply(s, c);
});
He || (He = function(n) {
  for (var s = arguments.length, i = new Array(s > 1 ? s - 1 : 0), c = 1; c < s; c++)
    i[c - 1] = arguments[c];
  return new n(...i);
});
const fe = b(Array.prototype.forEach), $t = b(Array.prototype.lastIndexOf), pt = b(Array.prototype.pop), Z = b(Array.prototype.push), Kt = b(Array.prototype.splice), Te = b(String.prototype.toLowerCase), Ce = b(String.prototype.toString), Me = b(String.prototype.match), Q = b(String.prototype.replace), Zt = b(String.prototype.indexOf), Qt = b(String.prototype.trim), L = b(Object.prototype.hasOwnProperty), w = b(RegExp.prototype.test), J = Jt(TypeError);
function b(o) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var s = arguments.length, i = new Array(s > 1 ? s - 1 : 0), c = 1; c < s; c++)
      i[c - 1] = arguments[c];
    return Fe(o, n, i);
  };
}
function Jt(o) {
  return function() {
    for (var n = arguments.length, s = new Array(n), i = 0; i < n; i++)
      s[i] = arguments[i];
    return He(o, s);
  };
}
function l(o, n) {
  let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Te;
  mt && mt(o, null);
  let i = n.length;
  for (; i--; ) {
    let c = n[i];
    if (typeof c == "string") {
      const m = s(c);
      m !== c && (jt(n) || (n[i] = m), c = m);
    }
    o[c] = !0;
  }
  return o;
}
function en(o) {
  for (let n = 0; n < o.length; n++)
    L(o, n) || (o[n] = null);
  return o;
}
function v(o) {
  const n = de(null);
  for (const [s, i] of Et(o))
    L(o, s) && (Array.isArray(i) ? n[s] = en(i) : i && typeof i == "object" && i.constructor === Object ? n[s] = v(i) : n[s] = i);
  return n;
}
function ee(o, n) {
  for (; o !== null; ) {
    const i = Xt(o, n);
    if (i) {
      if (i.get)
        return b(i.get);
      if (typeof i.value == "function")
        return b(i.value);
    }
    o = Vt(o);
  }
  function s() {
    return null;
  }
  return s;
}
const ut = S(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), xe = S(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Pe = S(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), tn = S(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), ke = S(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), nn = S(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), ft = S(["#text"]), ht = S(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Ue = S(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), dt = S(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), he = S(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), an = O(/\{\{[\w\W]*|[\w\W]*\}\}/gm), on = O(/<%[\w\W]*|[\w\W]*%>/gm), sn = O(/\$\{[\w\W]*/gm), rn = O(/^data-[\-\w.\u00B7-\uFFFF]+$/), cn = O(/^aria-[\-\w]+$/), _t = O(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), ln = O(/^(?:\w+script|data):/i), mn = O(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), At = O(/^html$/i), pn = O(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Tt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: cn,
  ATTR_WHITESPACE: mn,
  CUSTOM_ELEMENT: pn,
  DATA_ATTR: rn,
  DOCTYPE_NAME: At,
  ERB_EXPR: on,
  IS_ALLOWED_URI: _t,
  IS_SCRIPT_OR_DATA: ln,
  MUSTACHE_EXPR: an,
  TMPLIT_EXPR: sn
});
const te = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, un = function() {
  return typeof window > "u" ? null : window;
}, fn = function(n, s) {
  if (typeof n != "object" || typeof n.createPolicy != "function")
    return null;
  let i = null;
  const c = "data-tt-policy-suffix";
  s && s.hasAttribute(c) && (i = s.getAttribute(c));
  const m = "dompurify" + (i ? "#" + i : "");
  try {
    return n.createPolicy(m, {
      createHTML(D) {
        return D;
      },
      createScriptURL(D) {
        return D;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + m + " could not be created."), null;
  }
}, gt = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function wt() {
  let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : un();
  const n = (r) => wt(r);
  if (n.version = "3.3.2", n.removed = [], !o || !o.document || o.document.nodeType !== te.document || !o.Element)
    return n.isSupported = !1, n;
  let {
    document: s
  } = o;
  const i = s, c = i.currentScript, {
    DocumentFragment: m,
    HTMLTemplateElement: D,
    Node: P,
    Element: ne,
    NodeFilter: F,
    NamedNodeMap: bt = o.NamedNodeMap || o.MozNamedAttrMap,
    HTMLFormElement: Rt,
    DOMParser: Lt,
    trustedTypes: ie
  } = o, j = ne.prototype, Ot = ee(j, "cloneNode"), Dt = ee(j, "remove"), yt = ee(j, "nextSibling"), Nt = ee(j, "childNodes"), ae = ee(j, "parentNode");
  if (typeof D == "function") {
    const r = s.createElement("template");
    r.content && r.content.ownerDocument && (s = r.content.ownerDocument);
  }
  let _, V = "";
  const {
    implementation: ge,
    createNodeIterator: vt,
    createDocumentFragment: It,
    getElementsByTagName: Ct
  } = s, {
    importNode: Mt
  } = i;
  let A = gt();
  n.isSupported = typeof Et == "function" && typeof ae == "function" && ge && ge.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: Ee,
    ERB_EXPR: _e,
    TMPLIT_EXPR: Ae,
    DATA_ATTR: xt,
    ARIA_ATTR: Pt,
    IS_SCRIPT_OR_DATA: kt,
    ATTR_WHITESPACE: ze,
    CUSTOM_ELEMENT: Ut
  } = Tt;
  let {
    IS_ALLOWED_URI: qe
  } = Tt, d = null;
  const We = l({}, [...ut, ...xe, ...Pe, ...ke, ...ft]);
  let T = null;
  const Ge = l({}, [...ht, ...Ue, ...dt, ...he]);
  let u = Object.seal(de(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), X = null, oe = null;
  const x = Object.seal(de(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Be = !0, we = !0, Ye = !1, je = !0, H = !1, se = !0, k = !1, Se = !1, be = !1, z = !1, re = !1, ce = !1, Ve = !0, Xe = !1;
  const Ft = "user-content-";
  let Re = !0, $ = !1, q = {}, y = null;
  const Le = l({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let $e = null;
  const Ke = l({}, ["audio", "video", "img", "source", "image", "track"]);
  let Oe = null;
  const Ze = l({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), le = "http://www.w3.org/1998/Math/MathML", me = "http://www.w3.org/2000/svg", I = "http://www.w3.org/1999/xhtml";
  let W = I, De = !1, ye = null;
  const Ht = l({}, [le, me, I], Ce);
  let pe = l({}, ["mi", "mo", "mn", "ms", "mtext"]), ue = l({}, ["annotation-xml"]);
  const zt = l({}, ["title", "style", "font", "a", "script"]);
  let K = null;
  const qt = ["application/xhtml+xml", "text/html"], Wt = "text/html";
  let h = null, G = null;
  const Gt = s.createElement("form"), Qe = function(e) {
    return e instanceof RegExp || e instanceof Function;
  }, Ne = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(G && G === e)) {
      if ((!e || typeof e != "object") && (e = {}), e = v(e), K = // eslint-disable-next-line unicorn/prefer-includes
      qt.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? Wt : e.PARSER_MEDIA_TYPE, h = K === "application/xhtml+xml" ? Ce : Te, d = L(e, "ALLOWED_TAGS") ? l({}, e.ALLOWED_TAGS, h) : We, T = L(e, "ALLOWED_ATTR") ? l({}, e.ALLOWED_ATTR, h) : Ge, ye = L(e, "ALLOWED_NAMESPACES") ? l({}, e.ALLOWED_NAMESPACES, Ce) : Ht, Oe = L(e, "ADD_URI_SAFE_ATTR") ? l(v(Ze), e.ADD_URI_SAFE_ATTR, h) : Ze, $e = L(e, "ADD_DATA_URI_TAGS") ? l(v(Ke), e.ADD_DATA_URI_TAGS, h) : Ke, y = L(e, "FORBID_CONTENTS") ? l({}, e.FORBID_CONTENTS, h) : Le, X = L(e, "FORBID_TAGS") ? l({}, e.FORBID_TAGS, h) : v({}), oe = L(e, "FORBID_ATTR") ? l({}, e.FORBID_ATTR, h) : v({}), q = L(e, "USE_PROFILES") ? e.USE_PROFILES : !1, Be = e.ALLOW_ARIA_ATTR !== !1, we = e.ALLOW_DATA_ATTR !== !1, Ye = e.ALLOW_UNKNOWN_PROTOCOLS || !1, je = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, H = e.SAFE_FOR_TEMPLATES || !1, se = e.SAFE_FOR_XML !== !1, k = e.WHOLE_DOCUMENT || !1, z = e.RETURN_DOM || !1, re = e.RETURN_DOM_FRAGMENT || !1, ce = e.RETURN_TRUSTED_TYPE || !1, be = e.FORCE_BODY || !1, Ve = e.SANITIZE_DOM !== !1, Xe = e.SANITIZE_NAMED_PROPS || !1, Re = e.KEEP_CONTENT !== !1, $ = e.IN_PLACE || !1, qe = e.ALLOWED_URI_REGEXP || _t, W = e.NAMESPACE || I, pe = e.MATHML_TEXT_INTEGRATION_POINTS || pe, ue = e.HTML_INTEGRATION_POINTS || ue, u = e.CUSTOM_ELEMENT_HANDLING || {}, e.CUSTOM_ELEMENT_HANDLING && Qe(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (u.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && Qe(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (u.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (u.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), H && (we = !1), re && (z = !0), q && (d = l({}, ft), T = de(null), q.html === !0 && (l(d, ut), l(T, ht)), q.svg === !0 && (l(d, xe), l(T, Ue), l(T, he)), q.svgFilters === !0 && (l(d, Pe), l(T, Ue), l(T, he)), q.mathMl === !0 && (l(d, ke), l(T, dt), l(T, he))), L(e, "ADD_TAGS") || (x.tagCheck = null), L(e, "ADD_ATTR") || (x.attributeCheck = null), e.ADD_TAGS && (typeof e.ADD_TAGS == "function" ? x.tagCheck = e.ADD_TAGS : (d === We && (d = v(d)), l(d, e.ADD_TAGS, h))), e.ADD_ATTR && (typeof e.ADD_ATTR == "function" ? x.attributeCheck = e.ADD_ATTR : (T === Ge && (T = v(T)), l(T, e.ADD_ATTR, h))), e.ADD_URI_SAFE_ATTR && l(Oe, e.ADD_URI_SAFE_ATTR, h), e.FORBID_CONTENTS && (y === Le && (y = v(y)), l(y, e.FORBID_CONTENTS, h)), e.ADD_FORBID_CONTENTS && (y === Le && (y = v(y)), l(y, e.ADD_FORBID_CONTENTS, h)), Re && (d["#text"] = !0), k && l(d, ["html", "head", "body"]), d.table && (l(d, ["tbody"]), delete X.tbody), e.TRUSTED_TYPES_POLICY) {
        if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw J('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw J('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        _ = e.TRUSTED_TYPES_POLICY, V = _.createHTML("");
      } else
        _ === void 0 && (_ = fn(ie, c)), _ !== null && typeof V == "string" && (V = _.createHTML(""));
      S && S(e), G = e;
    }
  }, Je = l({}, [...xe, ...Pe, ...tn]), et = l({}, [...ke, ...nn]), Bt = function(e) {
    let t = ae(e);
    (!t || !t.tagName) && (t = {
      namespaceURI: W,
      tagName: "template"
    });
    const a = Te(e.tagName), p = Te(t.tagName);
    return ye[e.namespaceURI] ? e.namespaceURI === me ? t.namespaceURI === I ? a === "svg" : t.namespaceURI === le ? a === "svg" && (p === "annotation-xml" || pe[p]) : !!Je[a] : e.namespaceURI === le ? t.namespaceURI === I ? a === "math" : t.namespaceURI === me ? a === "math" && ue[p] : !!et[a] : e.namespaceURI === I ? t.namespaceURI === me && !ue[p] || t.namespaceURI === le && !pe[p] ? !1 : !et[a] && (zt[a] || !Je[a]) : !!(K === "application/xhtml+xml" && ye[e.namespaceURI]) : !1;
  }, N = function(e) {
    Z(n.removed, {
      element: e
    });
    try {
      ae(e).removeChild(e);
    } catch {
      Dt(e);
    }
  }, U = function(e, t) {
    try {
      Z(n.removed, {
        attribute: t.getAttributeNode(e),
        from: t
      });
    } catch {
      Z(n.removed, {
        attribute: null,
        from: t
      });
    }
    if (t.removeAttribute(e), e === "is")
      if (z || re)
        try {
          N(t);
        } catch {
        }
      else
        try {
          t.setAttribute(e, "");
        } catch {
        }
  }, tt = function(e) {
    let t = null, a = null;
    if (be)
      e = "<remove></remove>" + e;
    else {
      const f = Me(e, /^[\r\n\t ]+/);
      a = f && f[0];
    }
    K === "application/xhtml+xml" && W === I && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
    const p = _ ? _.createHTML(e) : e;
    if (W === I)
      try {
        t = new Lt().parseFromString(p, K);
      } catch {
      }
    if (!t || !t.documentElement) {
      t = ge.createDocument(W, "template", null);
      try {
        t.documentElement.innerHTML = De ? V : p;
      } catch {
      }
    }
    const E = t.body || t.documentElement;
    return e && a && E.insertBefore(s.createTextNode(a), E.childNodes[0] || null), W === I ? Ct.call(t, k ? "html" : "body")[0] : k ? t.documentElement : E;
  }, nt = function(e) {
    return vt.call(
      e.ownerDocument || e,
      e,
      // eslint-disable-next-line no-bitwise
      F.SHOW_ELEMENT | F.SHOW_COMMENT | F.SHOW_TEXT | F.SHOW_PROCESSING_INSTRUCTION | F.SHOW_CDATA_SECTION,
      null
    );
  }, ve = function(e) {
    return e instanceof Rt && (typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || !(e.attributes instanceof bt) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function");
  }, it = function(e) {
    return typeof P == "function" && e instanceof P;
  };
  function C(r, e, t) {
    fe(r, (a) => {
      a.call(n, e, t, G);
    });
  }
  const at = function(e) {
    let t = null;
    if (C(A.beforeSanitizeElements, e, null), ve(e))
      return N(e), !0;
    const a = h(e.nodeName);
    if (C(A.uponSanitizeElement, e, {
      tagName: a,
      allowedTags: d
    }), se && e.hasChildNodes() && !it(e.firstElementChild) && w(/<[/\w!]/g, e.innerHTML) && w(/<[/\w!]/g, e.textContent) || e.nodeType === te.progressingInstruction || se && e.nodeType === te.comment && w(/<[/\w]/g, e.data))
      return N(e), !0;
    if (!(x.tagCheck instanceof Function && x.tagCheck(a)) && (!d[a] || X[a])) {
      if (!X[a] && st(a) && (u.tagNameCheck instanceof RegExp && w(u.tagNameCheck, a) || u.tagNameCheck instanceof Function && u.tagNameCheck(a)))
        return !1;
      if (Re && !y[a]) {
        const p = ae(e) || e.parentNode, E = Nt(e) || e.childNodes;
        if (E && p) {
          const f = E.length;
          for (let R = f - 1; R >= 0; --R) {
            const M = Ot(E[R], !0);
            M.__removalCount = (e.__removalCount || 0) + 1, p.insertBefore(M, yt(e));
          }
        }
      }
      return N(e), !0;
    }
    return e instanceof ne && !Bt(e) || (a === "noscript" || a === "noembed" || a === "noframes") && w(/<\/no(script|embed|frames)/i, e.innerHTML) ? (N(e), !0) : (H && e.nodeType === te.text && (t = e.textContent, fe([Ee, _e, Ae], (p) => {
      t = Q(t, p, " ");
    }), e.textContent !== t && (Z(n.removed, {
      element: e.cloneNode()
    }), e.textContent = t)), C(A.afterSanitizeElements, e, null), !1);
  }, ot = function(e, t, a) {
    if (oe[t] || Ve && (t === "id" || t === "name") && (a in s || a in Gt))
      return !1;
    if (!(we && !oe[t] && w(xt, t))) {
      if (!(Be && w(Pt, t))) {
        if (!(x.attributeCheck instanceof Function && x.attributeCheck(t, e))) {
          if (!T[t] || oe[t]) {
            if (
              // First condition does a very basic check if a) it's basically a valid custom element tagname AND
              // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
              // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
              !(st(e) && (u.tagNameCheck instanceof RegExp && w(u.tagNameCheck, e) || u.tagNameCheck instanceof Function && u.tagNameCheck(e)) && (u.attributeNameCheck instanceof RegExp && w(u.attributeNameCheck, t) || u.attributeNameCheck instanceof Function && u.attributeNameCheck(t, e)) || // Alternative, second condition checks if it's an `is`-attribute, AND
              // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
              t === "is" && u.allowCustomizedBuiltInElements && (u.tagNameCheck instanceof RegExp && w(u.tagNameCheck, a) || u.tagNameCheck instanceof Function && u.tagNameCheck(a)))
            ) return !1;
          } else if (!Oe[t]) {
            if (!w(qe, Q(a, ze, ""))) {
              if (!((t === "src" || t === "xlink:href" || t === "href") && e !== "script" && Zt(a, "data:") === 0 && $e[e])) {
                if (!(Ye && !w(kt, Q(a, ze, "")))) {
                  if (a)
                    return !1;
                }
              }
            }
          }
        }
      }
    }
    return !0;
  }, st = function(e) {
    return e !== "annotation-xml" && Me(e, Ut);
  }, rt = function(e) {
    C(A.beforeSanitizeAttributes, e, null);
    const {
      attributes: t
    } = e;
    if (!t || ve(e))
      return;
    const a = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: T,
      forceKeepAttr: void 0
    };
    let p = t.length;
    for (; p--; ) {
      const E = t[p], {
        name: f,
        namespaceURI: R,
        value: M
      } = E, B = h(f), Ie = M;
      let g = f === "value" ? Ie : Qt(Ie);
      if (a.attrName = B, a.attrValue = g, a.keepAttr = !0, a.forceKeepAttr = void 0, C(A.uponSanitizeAttribute, e, a), g = a.attrValue, Xe && (B === "id" || B === "name") && (U(f, e), g = Ft + g), se && w(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, g)) {
        U(f, e);
        continue;
      }
      if (B === "attributename" && Me(g, "href")) {
        U(f, e);
        continue;
      }
      if (a.forceKeepAttr)
        continue;
      if (!a.keepAttr) {
        U(f, e);
        continue;
      }
      if (!je && w(/\/>/i, g)) {
        U(f, e);
        continue;
      }
      H && fe([Ee, _e, Ae], (lt) => {
        g = Q(g, lt, " ");
      });
      const ct = h(e.nodeName);
      if (!ot(ct, B, g)) {
        U(f, e);
        continue;
      }
      if (_ && typeof ie == "object" && typeof ie.getAttributeType == "function" && !R)
        switch (ie.getAttributeType(ct, B)) {
          case "TrustedHTML": {
            g = _.createHTML(g);
            break;
          }
          case "TrustedScriptURL": {
            g = _.createScriptURL(g);
            break;
          }
        }
      if (g !== Ie)
        try {
          R ? e.setAttributeNS(R, f, g) : e.setAttribute(f, g), ve(e) ? N(e) : pt(n.removed);
        } catch {
          U(f, e);
        }
    }
    C(A.afterSanitizeAttributes, e, null);
  }, Yt = function r(e) {
    let t = null;
    const a = nt(e);
    for (C(A.beforeSanitizeShadowDOM, e, null); t = a.nextNode(); )
      C(A.uponSanitizeShadowNode, t, null), at(t), rt(t), t.content instanceof m && r(t.content);
    C(A.afterSanitizeShadowDOM, e, null);
  };
  return n.sanitize = function(r) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = null, a = null, p = null, E = null;
    if (De = !r, De && (r = "<!-->"), typeof r != "string" && !it(r))
      if (typeof r.toString == "function") {
        if (r = r.toString(), typeof r != "string")
          throw J("dirty is not a string, aborting");
      } else
        throw J("toString is not a function");
    if (!n.isSupported)
      return r;
    if (Se || Ne(e), n.removed = [], typeof r == "string" && ($ = !1), $) {
      if (r.nodeName) {
        const M = h(r.nodeName);
        if (!d[M] || X[M])
          throw J("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (r instanceof P)
      t = tt("<!---->"), a = t.ownerDocument.importNode(r, !0), a.nodeType === te.element && a.nodeName === "BODY" || a.nodeName === "HTML" ? t = a : t.appendChild(a);
    else {
      if (!z && !H && !k && // eslint-disable-next-line unicorn/prefer-includes
      r.indexOf("<") === -1)
        return _ && ce ? _.createHTML(r) : r;
      if (t = tt(r), !t)
        return z ? null : ce ? V : "";
    }
    t && be && N(t.firstChild);
    const f = nt($ ? r : t);
    for (; p = f.nextNode(); )
      at(p), rt(p), p.content instanceof m && Yt(p.content);
    if ($)
      return r;
    if (z) {
      if (re)
        for (E = It.call(t.ownerDocument); t.firstChild; )
          E.appendChild(t.firstChild);
      else
        E = t;
      return (T.shadowroot || T.shadowrootmode) && (E = Mt.call(i, E, !0)), E;
    }
    let R = k ? t.outerHTML : t.innerHTML;
    return k && d["!doctype"] && t.ownerDocument && t.ownerDocument.doctype && t.ownerDocument.doctype.name && w(At, t.ownerDocument.doctype.name) && (R = "<!DOCTYPE " + t.ownerDocument.doctype.name + `>
` + R), H && fe([Ee, _e, Ae], (M) => {
      R = Q(R, M, " ");
    }), _ && ce ? _.createHTML(R) : R;
  }, n.setConfig = function() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Ne(r), Se = !0;
  }, n.clearConfig = function() {
    G = null, Se = !1;
  }, n.isValidAttribute = function(r, e, t) {
    G || Ne({});
    const a = h(r), p = h(e);
    return ot(a, p, t);
  }, n.addHook = function(r, e) {
    typeof e == "function" && Z(A[r], e);
  }, n.removeHook = function(r, e) {
    if (e !== void 0) {
      const t = $t(A[r], e);
      return t === -1 ? void 0 : Kt(A[r], t, 1)[0];
    }
    return pt(A[r]);
  }, n.removeHooks = function(r) {
    A[r] = [];
  }, n.removeAllHooks = function() {
    A = gt();
  }, n;
}
var St = wt();
const gn = /* @__PURE__ */ function() {
  const o = [
    {
      name: "localhost:6006",
      pattern: /^(http|https):?\/\/localhost:6006/
    },
    {
      name: "localhost:8080",
      pattern: /^(http|https):?\/\/localhost:8080\/site\/(ampmicrosites|joinameriprise)/
    },
    {
      name: "localhost:8081",
      pattern: /^(http|https):?\/\/localhost:8081\/site\/(ampmicrosites|joinameriprise)/
    },
    {
      name: "localhost:9100",
      pattern: /^(http|https):?\/\/localhost:9100/
    },
    {
      name: "localhostcms",
      pattern: /^(http|https):?\/\/localhost:(8080|8081)\/site\/_cmsinternal\/(ampmicrosites|joinameriprise)/
    },
    {
      name: "localhost:8080cms",
      pattern: /^(http|https):?\/\/localhost:8080\/site\/_cmsinternal\/(ampmicrosites|joinameriprise)/
    },
    {
      name: "localhost:8081cms",
      pattern: /^(http|https):?\/\/localhost:8081\/site\/_cmsinternal\/(ampmicrosites|joinameriprise)/
    },
    {
      name: "localhostpreview",
      pattern: /^(http|https):?\/\/localhost:(8080|8081)\/site\/(ampmicrosites|joinameriprise)\/preview/
    },
    {
      name: "devcms",
      pattern: /^(http|https):?\/\/cms-ws\d*\.dev\.ameriprise.com/
    },
    {
      name: "dev",
      pattern: /^(http|https):?\/\/www-ws\d*\.dev\.ameriprise.com\/(microsite|careers)/
    },
    {
      name: "devpreview",
      pattern: /^(http|https):?\/\/www-ws\d*\.dev\.ameriprise.com\/(microsite|careers)\/preview/
    },
    {
      name: "qawscms",
      pattern: /^(http|https):?\/\/cms-ws\d*\.qa\.ameriprise.com/
    },
    {
      name: "qaws",
      pattern: /^(http|https):?\/\/www-ws\d*\.qa\.ameriprise.com\/(microsite|careers)/
    },
    {
      name: "qawspreview",
      pattern: /^(http|https):?\/\/www-ws\d*\.qa\.ameriprise.com\/(microsite|careers)\/preview/
    },
    {
      name: "qacms",
      pattern: /^(http|https):?\/\/cms\.qa\.ameriprise.com/
    },
    {
      name: "qa",
      pattern: /^(http|https):?\/\/www\.qa\.ameriprise.com\/(microsite|careers)/
    },
    {
      name: "qapreview",
      pattern: /^(http|https):?\/\/www\.qa\.ameriprise.com\/(microsite|careers)\/preview/
    },
    {
      name: "prodcms",
      pattern: /^(http|https):?\/\/cms\.ameriprise.com/
    },
    {
      name: "prod",
      pattern: /^(http|https):?\/\/www\.ameriprise.com\/(microsite|careers)/
    },
    {
      name: "prodpreview",
      pattern: /^(http|https):?\/\/www\.ameriprise.com\/(microsite|careers)\/preview/
    }
  ];
  return function(s) {
    s = s || window.location.toString();
    let i;
    return o.forEach(function(c) {
      c.pattern.test(s) && (i = c.name);
    }), i = i ?? "prod", i;
  };
}(), En = (o) => {
  let n = "", s = "", i = "", c = "", m = "";
  switch (o) {
    case "localhost:8080":
      n = "http://localhost:8080/site/ampmicrosites/", s = "/site/binaries/", i = "http://localhost:8080/site/cfgapi/hst/menus/local-ampmicrosites/", c = "http://localhost:8080/site/cfgapi/hst/menus-ext/local-ampmicrosites/", m = "https://www.qa.ameriprise.com/api/advisorsv22/json/";
      break;
    case "localhost:8080cms":
      n = "http://localhost:8080/site/_cmsinternal/ampmicrosites/", s = "/site/binaries/", i = "http://localhost:8080/site/_cmsinternal/cfgapi/hst/menus/local-ampmicrosites/", c = "http://localhost:8080/site/_cmsinternal/cfgapi/hst/menus-ext/local-ampmicrosites/";
      break;
    case "localhost:8081cms":
      n = "http://localhost:8081/site/_cmsinternal/ampmicrosites/", s = "/site/binaries/", i = "http://localhost:8081/site/cfgapi/hst/menus/local-ampmicrosites/", c = "http://localhost:8081/site/cfgapi/hst/menus-ext/local-ampmicrosites/";
      break;
    case "localhostpreview":
      n = "http://localhost:8080/site/ampmicrosites/preview/", s = "/site/binaries/", i = "http://localhost:8080/site/cfgapi/hst/menus/local-ampmicrosites/preview/", c = "http://localhost:8080/site/cfgapi/hst/menus-ext/local-ampmicrosites/preview/", m = "https://www.qa.ameriprise.com/api/advisorsv22/json/";
      break;
    case "localhost:8081":
      n = "http://localhost:8081/site/ampmicrosites/", s = "/site/binaries/", i = "http://localhost:8081/site/cfgapi/hst/menus/local-ampmicrosites/", c = "http://localhost:8081/site/cfgapi/hst/menus-ext/local-ampmicrosites/", m = "https://www.qa.ameriprise.com/api/advisorsv22/json/";
      break;
    case "localhost:6006":
      n = "/microsite/", s = "/binaries/", i = "/cfgapi/hst/menus/ampmicrosites/", c = "/cfgapi/hst/menus-ext/ampmicrosites/";
      break;
    case "localhost:9100":
      n = "https://www.qa.ameriprise.com/microsite/", s = "https://www.qa.ameriprise.com/microsite/binaries/", i = "https://www.qa.ameriprise.com/cfgapi/hst/menus/ampmicrosites/", c = "https://www.qa.ameriprise.com/cfgapi/hst/menus-ext/ampmicrosites/";
      break;
    case "devcms":
    case "qawscms":
    case "qacms":
    case "prodcms":
      n = "/site/_cmsinternal/microsite/", s = "/site/_cmsinternal/binaries/", i = "/site/_cmsinternal/cfgapi/hst/menus/ampmicrosites/", c = "/site/_cmsinternal/cfgapi/hst/menus-ext/ampmicrosites/";
      break;
    case "dev":
      n = "/microsite/", s = "/binaries/", i = "/cfgapi/hst/menus/ampmicrosites/", c = "/cfgapi/hst/menus-ext/ampmicrosites/", m = "https://www.qa.ameriprise.com/api/advisorsv22/json/";
      break;
    case "qaws":
    case "qa":
    case "prod":
      n = "/microsite/", s = "/binaries/", i = "/cfgapi/hst/menus/ampmicrosites/", c = "/cfgapi/hst/menus-ext/ampmicrosites/", m = "/api/advisorsv22/json/";
      break;
    case "devpreview":
    case "qawspreview":
    case "qapreview":
      n = "/microsite/preview/", s = "/binaries/", i = "/cfgapi/hst/menus/ampmicrosites-preview/", c = "/cfgapi/hst/menus-ext/ampmicrosites-preview/", m = "https://www.qa.ameriprise.com/api/advisorsv22/json/";
      break;
  }
  return { base: n, baseGallery: s, menuBase: i, menuBaseWithParams: c, advisor: m };
}, Y = {
  PRODUCTION: "production",
  QA: "qa",
  DEV: "dev",
  LOCAL: "local",
  PREVIEW: "preview",
  UNKNOWN: "unknown"
};
function _n() {
  const o = /localhost|127\.0\.0\.1/i.test(window.location.toString()) || window.location.port === "8081", n = /(www|www1)(-ws1|preview|demo)?(\.qa.stage|\.qa|.dev)?\.ameriprise\.com/.test(
    window.location.toString()
  ), s = /dev|ws1.dev|qa|ws1.qa|qa.stage|preview|127\.0\.0\.1|local/i.test(window.location.toString()) || window.location.port === "8081", c = !s && !(n && s), m = /dev|ws1.dev\./i.test(window.location.toString()), D = /qa|ws1.qa\./i.test(window.location.toString()), P = /preview\./i.test(window.location.toString());
  switch (!0) {
    case c:
      return Y.PRODUCTION;
    case o:
      return Y.LOCAL;
    case D:
      return Y.QA;
    case m:
      return Y.DEV;
    case P:
      return Y.PREVIEW;
    default:
      return Y.UNKNOWN;
  }
}
function hn(o) {
  const n = document.createElement("textarea");
  return n.innerText = St.sanitize(o, { ADD_ATTR: ["target"] }), n.innerText;
}
function dn(o) {
  const n = /&(nbsp|amp|quot|lt|gt);/g, s = {
    nbsp: " ",
    amp: "&",
    quot: "'",
    lt: "<",
    gt: ">"
  };
  return o.replace(n, function(i, c) {
    return s[c];
  }).replace(/&#(\d+);/gi, function(i, c) {
    const m = parseInt(c, 10);
    return String.fromCharCode(m);
  });
}
function An(o) {
  return St.sanitize(dn(hn(o)), { ADD_ATTR: ["target"] });
}
function wn(o) {
  return o.replace(/&amp;/g, "&");
}
function Sn(o) {
  try {
    if (o.startsWith("/") || o.startsWith("https://"))
      return o;
  } catch {
  }
  return "";
}
const Tn = [
  "www.ameriprise.com",
  "www.ameripriseadvisors.com",
  "www.qa.ameriprise.com",
  "www-ws1.qa.ameriprise.com",
  "www-ws2.qa.ameriprise.com",
  "www-ws3.qa.ameriprise.com",
  "www-ws4.qa.ameriprise.com",
  "www-ws5.qa.ameriprise.com",
  "perf.qa.ameriprise.com",
  "secure.ameriprise.com",
  "secure-01.qa.ameriprise.com"
];
function bn(o) {
  try {
    const n = "", s = new URL(
      o,
      o.includes("https") || o.includes("http") ? void 0 : window.location.origin
    ), i = ["http:", "https:"], c = s.hostname;
    if (!i.includes(s.protocol)) return n;
    const m = c === "localhost", D = /^127\.\d+\.\d+\.\d+$/.test(c), P = /^(10\.|192\.168\.|172\.(1[6-9]|2[0-9]|3[0-1])\.)/.test(c), ne = /^169\.254\./.test(c);
    return m || D || P || ne || c === "::1" || !Tn.includes(c) ? n : o;
  } catch (n) {
    return console.warn(n), "";
  }
}
export {
  En as A,
  An as a,
  _n as b,
  wn as c,
  gn as g,
  bn as i,
  St as p,
  Sn as s
};
//# sourceMappingURL=common-utils-DjDyp7mO.mjs.map
